import React from 'react';
import PropTypes from 'prop-types';
import ScrollButton from './ScrollButton';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Components/Button/ScrollButton',
  component: ScrollButton,
  parameters: {
    layout: 'centered',
    ...generateComponentDocs(
      // What problem does it solve?
      '\nThe `ScrollButton` component provides users with an interactive UI element for scrolling elements inside a container.\n\n',
      // When & how to use it?
      '\nUse the `ScrollButton` component when you need to enable scrolling within a container.\n\n',
      // Current Usage
      `\nThe \`ScrollButton\` component is used throughout the application, including in:
      \n- The Tag component\n\n`,
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    direction: {
      control: { type: 'select' },
      options: ['left', 'right'],
    },
  },
};

const ScrollButtonTemplate = ({
  onClick = () => { },
  direction = 'left',
  isDisabled = false,
}) => {
  return (<ScrollButton onClick={onClick} direction={direction} isDisabled={isDisabled} />);
};

const Template = ScrollButtonTemplate.bind({});

export const LeftScrollButtonVariant = Template.bind({});
LeftScrollButtonVariant.args = {
  direction: 'left',
};
LeftScrollButtonVariant.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThe `LeftScrollButtonVariant` is used as a scroll button to indicate scrolling to the left.\n\n',
  // Where is it currently used in the product?
  '\nThis variant is used in displaying tag list components.\n\n',
);

export const RightScrollButtonVariant = Template.bind({});
RightScrollButtonVariant.args = {
  direction: 'right',
};
RightScrollButtonVariant.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThe `RightScrollButtonVariant` is used as a scroll button to indicate scrolling to the right.\n\n',
  // Where is it currently used in the product?
  '\nThis variant is used in displaying tag list components.\n\n',
);

ScrollButtonTemplate.propTypes = {
  onClick: PropTypes.func,
  direction: PropTypes.oneOf(['left', 'right']),
  isDisabled: PropTypes.bool,
};
